export class ReportViewerParameterModel {
  name: string;
  value: string;
}
